export enum MixPanelRegion {
  US = 'us',
  EU = 'eu'
}
